import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { TextInput } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import Text, { Small, Large, H2 } from '@dbk/ui-text';

import { LoadingCircle } from '../../../components/common/loading';
import {
  VASCO_STATUSES,
  VASCO_MODAL_TYPES,
  VASCO_API_ERROR_CODES,
  DOT_UNICODE
} from '../../../constants';

const MAX_VS = 8;
const counter = 0;
let incorrect = false

class Vasco extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      vascoToken: '',
      isLoading: false,
      errorTxt: '',
      maskedToken: ''
    };
    this.handleValidateToken = this.handleValidateToken.bind(this);
    this.handleTokenChange = this.handleTokenChange.bind(this);
    this.handleSubmitToken = this.handleSubmitToken.bind(this);
  }
  componentDidMount() {
    if (document.querySelector('input.rsaBox')) {
      document.querySelector('input.rsaBox').focus()
    }
    if (this.props.vascoauthentication.otpVerified && this.props.vascoauthentication.vascoAuthorised) {
      // API call to send new temp password to user’s email
      this.props.forgotPassword.generateTemporaryPwd();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { vascoToken, isLoading } = this.state;
    const { i18n: { messages }, vascoauthentication: { otpStatus, statusCode } } = this.props;
    if (prevProps.otpStatus !== otpStatus) {
      if (otpStatus === false) {
        if (incorrect) {
          this.props.setOTPStatus(undefined);
          this.props.setOTPStatuscode(undefined);
          this.setState({ isLoading: false, errorTxt: messages['app.vasco.error.invalid'], vascoToken:''});
        }
        if ((statusCode === VASCO_API_ERROR_CODES.otpIncorrect || statusCode === VASCO_API_ERROR_CODES.otpReplay) && !incorrect) {
          this.props.setOTPStatus(undefined);
          this.props.setOTPStatuscode(undefined);
          incorrect = true;
          this.setState({ isLoading: false, errorTxt: messages['app.vasco.error.invalid'], vascoToken:''});
        } else if (statusCode === VASCO_API_ERROR_CODES.userLocked) {
          this.props.setVascoModalType(VASCO_MODAL_TYPES.failExceededOtp);
          this.handleUpdateActivationStatus();
        } else if (statusCode === VASCO_API_ERROR_CODES.invalidSession) {
          this.props.setOTPStatus(undefined);
          this.props.setOTPStatuscode(undefined);
          incorrect = true;
          this.setState({ isLoading: false, errorTxt: messages['app.auth.logoutExpireSuccess.text'] });
          this.props.auth.logout();
        }
      }
      if(document.querySelector('.otp-error')){ 
        document.querySelector('.otp-error').focus();
      }
    }
   
  }

  handleValidateToken() {
    const {
      i18n: { messages },
    } = this.props;
    const { vascoToken, isLoading } = this.state;
    this.setState({ isLoading: true, errorTxt: '' });
    incorrect = false;
    const vascoOTP = vascoToken;
    const isnum = /^\d+$/.test(vascoOTP);

    if (isnum || vascoOTP === '') {
      if (vascoOTP.length < 8 || vascoOTP.length > 8) {
        this.setState({
          isLoading: false,
          errorTxt: messages['app.vasco.error.minLength'],
          vascoToken:''
        });
      } else {
        if (vascoOTP === '00000000') {
          this.setState({
            isLoading: false,
            errorTxt: messages['app.vasco.error.allZeros'],
            vascoToken:''
          });
          if(document.querySelector('.otp-error')){ 
            document.querySelector('.otp-error').focus();
          }
          return;
        }
        this.routePage(vascoOTP);
      }
    } else {
      this.setState({
        isLoading: false,
        errorTxt: messages['app.vasco.error.nonNumeric'],
        vascoToken:''
      });
    }
    if(document.querySelector('.otp-error')){ 
      document.querySelector('.otp-error').focus();
    }
  }

  routePage(vascoOTP) {
    if(this.props.hrmw.isManageContactDetails){
      setTimeout(() => {
        this.props.hrmw.signContact(vascoOTP);
      }, 1000);
    }
    else{
      setTimeout(() => {
        this.props.onValidateToken(vascoOTP);
      }, 1000);
    }
  }

  handleSubmitToken(event) {
    const {
      nativeEvent: { key },
    } = event;
    if (key == 'Enter' && this.props.vascoauthentication.countDown === null) {
      this.handleValidateToken();
    }
  }

  handleUpdateActivationStatus() {
    this.setState({ isLoading: false, errorTxt: '' });
    // this.props.updateActivationStatus(VASCO_STATUSES.pinError, false);
  }

  handleTokenChange(event) {
    const value = event.target.value.toString();
    this.setState({ vascoToken: value });
    // WMCE-7106 Commenting below code for revisit
    // let newVascoToken = '';
    // const value = event.target.value.toString();
    // const vascoField = document.getElementById('vascotoken');
    // const startPosition = vascoField.selectionStart;
    // const endPosition = vascoField.selectionEnd;
    // const lastRecord = value.slice(value.length - 1);

    // if(this.state.vascoToken.length < value.length && !isNaN(parseInt(lastRecord))){
    //   newVascoToken = `${this.state.vascoToken}${lastRecord}`;
    // } else if(this.state.vascoToken.length > value.length && isNaN(parseInt(lastRecord)) && value.length === startPosition && value.length === endPosition){
    //   newVascoToken = this.state.vascoToken.slice(0, - 1);
    // } else {
    //   newVascoToken = this.state.vascoToken.slice(0,startPosition) + this.state.vascoToken.slice(startPosition+1);
    // }
    // this.setState({ vascoToken: newVascoToken, maskedToken: DOT_UNICODE.repeat(value.length)});
  }

  render() {
    const { vascoToken, isLoading } = this.state;
    const {
      i18n: { messages },
      vascoauthentication: { otpStatus, statusCode },
    } = this.props;


    const textStyleWhite = {
      color: '#ffffff',
    };

    if (isLoading && !this.props.vascoauthentication.otpStatus) {
      return (
        <LoadingCircle noPadding isPage={false} />
      )
    }
      return (
        <div className="scene">
          <div className="row vasco ">
            <div className="columns small-12">
              <div className="module">
                <div>
                  <div>
                    <div className="large-12 instructions-block instruction-border">
                      <div  tabIndex={0} className="text--primary text-center pad-bottom-40">
                        <Text size= "large" >
                          {messages['app.vasco.ch.instructions.main']}
                        </Text>
                      </div>

                      <div tabIndex={0} className="large-4 medium-4 columns text-border" aria-label={`Step1: ${messages['app.vasco.instructions.step1']}`}>
                        <H2
                          className="vasco big-letter-vasco"
                        >
                          1
                        </H2>
                        <Text className="text-left">
                          {messages['app.vasco.instructions.step1']}
                        </Text>
                      </div>
                      <div tabIndex={0} className="large-4 medium-4 columns text-border" aria-label={`Step2: ${messages['app.vasco.instructions.step2']}`}>
                        <H2
                          className="vasco big-letter-vasco"
                        >
                          2
                        </H2>
                        <Text className="text-left">
                          {messages['app.vasco.instructions.step2']}
                        </Text>
                      </div>
                      <div tabIndex={0} className="large-4 medium-4 columns displayFlex" aria-label={`Step3: ${messages['app.vasco.instructions.step3']}`}>
                        <H2
                          className="vasco big-letter-vasco"
                        >
                          3
                        </H2>
                        <Text className="text-left">
                          {messages['app.vasco.instructions.step3']}
                        </Text>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div className="column small-12 medium-12 large-push-1 large-10">
                      <div className="pad-top-40 text-center">
                        <Text size= "large" tabIndex={0}>
                          {messages['app.vasco.instructions.inputLabel']}
                        </Text>
                      </div>
                      
                      <div className="text-center otp-error" aria-label={this.state.errorTxt + " " + messages['app.vasco.rasp.alert']} tabIndex={this.state.errorTxt !== '' ? '0' :'-1'} >
                        {this.state.errorTxt !== '' ? (
                          <Text type="error">
                            {this.state.errorTxt}
                          </Text>
                        ) : (
                            ''
                          )}
                      </div>
                      <div className="text--primary text-center pad-bottom-40 pad-top-20 rsaDisabled">
                        <TextInput
                          disabled={ this.props.vascoauthentication.countDown !== null }
                          textID="input-userId"
                          name="userId"
                          maxLength={8}
                          type="password"
                          aria-label={messages['app.auth.vasco.otp.generate.title']}
                          value={this.state.vascoToken}
                          id="vascotoken"
                          onChange={(event) => this.handleTokenChange(event)}
                          onKeyPress={(event) => this.handleSubmitToken(event)}
                          ref="vascoToken"
                          autoComplete="new-password"
                          letterSpacing={10}
                          className="rsaBox"
                          size="large"
                          style={{ textAlign: 'center', width: '70%' }}
                        />
                      </div>
                      <div className="row vasco-button-row">
                        <div id="btn_validateOtp_vasco" className="small-12 medium-4 columns medium-centered">
                          <Button size= "large" testID='btn_validate_otp_vasco' fullWidth onPress={this.handleValidateToken} disabled={this.props.vascoauthentication.countDown > 0}>
                            { this.props.vascoauthentication.countDown > 0 ? (messages['app.vasco.validate.token.waitButton'] + ` (${this.props.vascoauthentication.countDown})`): messages['app.vasco.validate.token.otp.button'] }
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );



  }
}

Vasco.propTypes = {};

export default createContainer({
  $queries: {
    onValidateToken: {
      $call: 'vascoauthentication.validateVascoPwd',
    },
    updateActivationStatus: {
      $call: 'vascoauthentication.updateActivationStatus',
    },
    setVascoModalType: {
      $call: 'vascoauthentication.setVascoModalType',
    },
    vascoauthentication: {
      otpStatus: true,
      statusCode: true,
      vascoAuthorised: true,
      countDown: true
    },
    setOTPStatus: {
      $call: 'vascoauthentication.setOTPStatus',
    },
    setOTPStatuscode: {
      $call: 'vascoauthentication.setOTPStatuscode',
    },
    screen: {
      width: true,
      height: true,
      isSmall: true,
    },
    i18n: {
      messages: true,
    },
    auth: {
      logout: { $call: 'logout' }
    },
    hrmw: {
      signContact: { $call: 'signContact' },
      isManageContactDetails : true
    }
  },
})(Vasco);
